import {
	CurrentUserProvider,
	CurrentUserRoleProvider,
	DropdownOptionsProvider,
	QueryProvider,
	StringsProvider,
	TenantProvider,
	ThemeProvider,
} from './components/providers';
import { Bootstrap } from './modules';

export const App = (): JSX.Element => {
	return (
		<ThemeProvider>
			<QueryProvider>
				<TenantProvider>
					<StringsProvider>
						<CurrentUserRoleProvider>
							<CurrentUserProvider>
								<DropdownOptionsProvider>
									<Bootstrap />
								</DropdownOptionsProvider>
							</CurrentUserProvider>
						</CurrentUserRoleProvider>
					</StringsProvider>
				</TenantProvider>
			</QueryProvider>
		</ThemeProvider>
	);
};
